import "../assets/useImageStyles.css";
import { h as H, defineComponent as L, ref as s, watchEffect as x, openBlock as b, createElementBlock as A, createBlock as $, unref as k, createCommentVNode as M, computed as h } from "vue";
import { n as I } from "./useStore.CDG6wbfK.js";
import { g as C } from "./Text.vue_vue_type_style_index_0_lang.CqNxQPnN.js";
import { D as p } from "./maps.DxC18PqJ.js";
const W = (l, n) => {
  const e = "http://www.w3.org/2000/svg", t = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5 3.25A1.75 1.75 0 003.25 5v6.523l2.886-2.887.01-.01c.5-.48 1.11-.767 1.77-.767.66 0 1.271.287 1.77.767l.011.01 1.97 1.97.303-.303.01-.01c.5-.48 1.11-.768 1.77-.768.66 0 1.27.287 1.77.768l.01.01 1.22 1.22V5A1.75 1.75 0 0015 3.25H5zm11.75 10.394l-2.275-2.275c-.272-.26-.523-.344-.725-.344-.202 0-.453.084-.725.344l-.298.298 1.137 1.136a.75.75 0 01-1.061 1.06l-1.666-1.665-.001-.002-2.494-2.493c-.272-.26-.523-.344-.725-.344-.202 0-.453.083-.726.344L3.25 13.644V15A1.75 1.75 0 005 16.75h10A1.75 1.75 0 0016.75 15v-1.356zM1.75 15A3.25 3.25 0 005 18.25h10A3.25 3.25 0 0018.25 15V5A3.25 3.25 0 0015 1.75H5A3.25 3.25 0 001.75 5v10zm10-8.333a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H12.5a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (l.title) {
    const m = document.createElementNS(e, "title");
    m.textContent = l.title, t.appendChild(m);
  }
  const c = Array.from((t == null ? void 0 : t.attributes) ?? []).reduce((m, g) => ({
    ...m,
    [g.name]: g.value
  }));
  return H(
    "svg",
    {
      ...c,
      ...n.attrs,
      role: "img",
      innerHTML: t.innerHTML
    }
  );
}, D = ["data-module-id", "data-no-image"], U = ["data-image-loaded", "src", "alt"], E = /* @__PURE__ */ L({
  __name: "ImageWithBehaviour",
  props: {
    moduleProps: {},
    maxWidth: {},
    maxHeight: {}
  },
  emits: ["naturalImageHeight"],
  setup(l, { emit: n }) {
    const e = l, r = s(), t = s(), c = s(), m = s(e.maxWidth), g = s(e.maxHeight), v = s(!1), a = s(!1), d = s(1), o = I(), f = n;
    function w() {
      if (r.value) {
        const {
          naturalWidth: i,
          naturalHeight: u
        } = r.value;
        d.value = i / u, v.value = !0, f("naturalImageHeight", u);
      }
    }
    function _(i) {
      v.value = !1, a.value = !0;
      const u = new Image();
      u.onload = () => {
        t.value = i, u.remove();
      }, u.onerror = () => {
        t.value = null, u.remove();
      }, u.src = i;
    }
    x(() => {
      if (e.moduleProps.image) {
        const i = o == null ? void 0 : o.literals.getLocaleImageUrl(e.moduleProps.image);
        i && i !== t.value && _(i), c.value = o == null ? void 0 : o.literals.getLocaleImageUrl(e.moduleProps.image);
      }
    }), x(() => {
      const i = e.moduleProps.maxWidth ? Math.min(e.moduleProps.maxWidth, e.maxWidth) : e.maxWidth;
      g.value = Math.min(e.maxHeight, i / d.value), m.value = g.value * d.value;
    });
    function P() {
      const i = C(e.moduleProps.behaviour.type);
      o == null || o.handlers.callHandler(i, e.moduleProps.id);
    }
    return (i, u) => (b(), A("div", {
      class: "thn--tool-image-with-behaviour",
      "data-module-id": e.moduleProps.id,
      "data-no-image": !t.value && !a.value,
      onClick: P
    }, [
      !t.value && !a.value ? (b(), $(k(W), {
        key: 0,
        class: "thn--tool-image-with-behaviour__icon"
      })) : M("", !0),
      t.value ? (b(), A("img", {
        key: 1,
        class: "thn--tool-image-with-behaviour__image",
        ref_key: "imageDom",
        ref: r,
        "data-image-loaded": v.value,
        src: t.value,
        alt: c.value,
        onLoad: w
      }, null, 40, U)) : M("", !0)
    ], 8, D));
  }
});
function N(l, n) {
  const e = I(), r = h(() => {
    var a;
    return (a = l.value) != null && a.image ? e == null ? void 0 : e.literals.getLocaleImageUrl(l.value.image) : "";
  }), t = h(() => {
    var a;
    return (a = l.value) != null && a.imageMobile ? e == null ? void 0 : e.literals.getLocaleImageUrl(l.value.imageMobile) : "";
  }), c = h(() => {
    var a;
    return (a = l.value) != null && a.image ? e == null ? void 0 : e.literals.getLocaleImageAlt(l.value.image) : "";
  }), m = h(() => {
    var a;
    return (a = l.value) != null && a.imageMobile ? e == null ? void 0 : e.literals.getLocaleImageAlt(l.value.imageMobile) : "";
  }), g = h(() => n.value === p.Mobile && t.value || !r.value ? t.value : r.value), v = h(() => n.value === p.Mobile && m.value || !r.value ? m.value : c.value);
  return {
    imageUrl: g,
    imageAlt: v
  };
}
const y = (l, n, e = s("left")) => ({
  imageStyles: h(() => {
    var o, f;
    if (n.value === p.Desktop && !((o = l.value) != null && o.imagePadding) || n.value === p.Mobile && !((f = l.value) != null && f.imageMobilePadding)) return "";
    const t = n.value === p.Mobile ? l.value.imageMobilePadding : l.value.imagePadding;
    if (!t) return "";
    const {
      top: c,
      bottom: m,
      left: g,
      right: v,
      format: a
    } = t, d = {
      top: `${c}${a}`,
      bottom: e.value !== "top" ? `${m}${a}` : "0px",
      right: e.value !== "left" ? `${v}${a}` : "0px",
      left: e.value !== "right" ? `${g}${a}` : "0px"
    };
    return `
      padding: ${d.top} ${d.right} ${d.bottom} ${d.left};
    `;
  })
});
export {
  E as _,
  y as a,
  W as i,
  N as u
};
//# sourceMappingURL=useImageStyles.DS4yuB--.js.map
